/**
 * SkillDelivery Platform
 * EVM Gauge Component - Visual gauge for SPI, CPI, TCPI
 *
 * Conference Sprint S2b: Performance index visualization
 */

import React from 'react';
import './EVMGauge.css';

const EVMGauge = ({ label, value, type, description }) => {
  // Determine color based on value and type
  const getColor = () => {
    if (type === 'tcpi') {
      if (value > 1.2) return '#ef4444'; // Red - very difficult
      if (value > 1.1) return '#f59e0b'; // Yellow - challenging
      return '#22c55e'; // Green - achievable
    }
    // For SPI and CPI
    if (value >= 1.0) return '#22c55e';  // Green - good
    if (value >= 0.9) return '#f59e0b';  // Yellow - caution
    return '#ef4444';  // Red - problem
  };

  const getEmoji = () => {
    if (type === 'tcpi') {
      if (value > 1.2) return '🚨';
      if (value > 1.1) return '⚠️';
      return '✅';
    }
    if (value >= 1.0) return '✅';
    if (value >= 0.9) return '⚠️';
    return '😟';
  };

  const getStatus = () => {
    if (type === 'spi') {
      if (value >= 1.0) return 'On Schedule';
      if (value >= 0.9) return 'Slightly Behind';
      return 'Behind Schedule';
    }
    if (type === 'cpi') {
      if (value >= 1.0) return 'Under Budget';
      if (value >= 0.9) return 'Slightly Over';
      return 'Over Budget';
    }
    if (type === 'tcpi') {
      if (value > 1.2) return 'Very Difficult';
      if (value > 1.1) return 'Challenging';
      return 'Achievable';
    }
    return '';
  };

  // Calculate gauge rotation (0.5 to 1.5 maps to -90 to 90 degrees)
  const normalizedValue = Math.max(0.5, Math.min(1.5, value));
  const rotation = ((normalizedValue - 0.5) / 1.0) * 180 - 90;

  return (
    <div className="evm-gauge">
      <div className="gauge-label">{label}</div>

      <div className="gauge-visual">
        <div className="gauge-background">
          <div className="gauge-zone red" />
          <div className="gauge-zone yellow" />
          <div className="gauge-zone green" />
        </div>

        <div
          className="gauge-needle"
          style={{
            transform: `rotate(${rotation}deg)`,
            backgroundColor: getColor()
          }}
        />

        <div className="gauge-center">
          <span className="gauge-emoji">{getEmoji()}</span>
          <span className="gauge-value" style={{ color: getColor() }}>
            {value.toFixed(2)}
          </span>
        </div>
      </div>

      <div className="gauge-status" style={{ color: getColor() }}>
        {getStatus()}
      </div>

      <div className="gauge-description">
        {description}
      </div>

      <div className="gauge-scale">
        <span>0.5</span>
        <span>1.0</span>
        <span>1.5</span>
      </div>
    </div>
  );
};

export default EVMGauge;
